if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.modalDrawer = document.querySelector('.modal-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        // crazy workaround to get the wishlist button to work
        this.wishlistButton = this.querySelector('.js-wishlist');
        this.wishlistContents = [];

        this.updateWishlistButton = this.updateWishlistButton.bind(this);
        this.updateWishlistButton();
        this.variantIdInput.addEventListener('change', () => {
          this.updateWishlistButton(false, false);
        });

        if (this.wishlistButton) {
          this.wishlistButton.addEventListener('click', (evt) => {
            evt.preventDefault();

            const currentVariant = JSON.parse(
              this.closest('.product').querySelector('[data-selected-variant]').innerHTML
            );

            const productId = this.wishlistButton.getAttribute('data-product-id');
            const productUrl = this.wishlistButton.getAttribute('data-url');
            const variantOptionName = currentVariant.options.join(' / ');
            const variantOptionObject = {};
            variantOptionObject[variantOptionName] = currentVariant.id;

            const isWishlisted = this.wishlistButton.classList.contains('is-wishlisted');
            const operation = isWishlisted ? 'removeFromWishList' : 'addToWishList';

            const productTitle = this.wishlistButton.getAttribute('data-product-title');
            const variantTitle = currentVariant.title;


            window._swat[operation](
              {
                epi: currentVariant.id, // product variant id
                du: productUrl, // product url
                empi: productId * 1, // product master id
                iu: currentVariant.featuredImage?.src,
                pr: currentVariant.price * 0.01,
                variants: [variantOptionObject],
                cprops: {
                  'locale' : Shopify?.locale || '',
                  'product_title': productTitle || '',
                  'variant_title': variantTitle || '',
                }
              },
              () => {
                this.updateWishlistButton(!isWishlisted);
                console.log('Added to wishlist');
              }
            );

            console.log('Wishlist button clicked');
          });
        }

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';



      }

      updateWishlistButton(forceWishlisted = false, fetchLists = true) {
        let currentVariant = {};
        try {
          currentVariant = JSON.parse(this.closest('.product').querySelector('[data-selected-variant]').innerHTML);
        } catch (e) {
          console.log(e);
        }

        const updateFill = (wishlisted) => {
          const wishlistedVariantIds = [];

          (this.wishlistContents || []).forEach((list) => {
            (list.listcontents || []).forEach((item) => {
              wishlistedVariantIds.push(item.epi);
            });
          });

          const isWishlisted = wishlisted || wishlistedVariantIds.includes(currentVariant.id);
          this.wishlistButton ? this.wishlistButton.classList.toggle('is-wishlisted', isWishlisted) : null;
        };

        updateFill(forceWishlisted);

        const callSwym = () => {
          if (fetchLists) {
            window._swat.fetchLists({
              callbackFn: (lists) => {
                this.wishlistContents = lists;
                updateFill();
              },
              errorFn: console.error,
            });
          }
        };

        if (window._swat) {
          callSwym();
        } else {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(callSwym);
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            this.modalDrawer.classList.remove('active');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButtonText.textContent = text || '\xa0' ;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = text || window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
if (!customElements.get('product-description')) {
  class ProductDescription extends HTMLElement {
    constructor() {
      super();

      // Store original content once when component is created
      const contentElement = this.querySelector('.product__description--tabs .content');
      this.originalDetailsHTML = contentElement?.innerHTML || '';
      this.expandReadMore = false;
      
      // Initialize elements
      this.tabs = this.querySelectorAll('.tab');
      this.readMore = this.querySelector('.js-read-more');
  
      // Bind the event handler to this instance
      this.handleReadMoreClick = this.handleReadMoreClick.bind(this);
      
      this.initializeReadMore();
      this.initializeTabs();
  
      // Listen for variant changes
      document.addEventListener('variant:changed', () => {
        // Only reinitialize tabs, not the read more functionality
        this.initializeTabs();
        this.resetReadMoreState();
      });
  
      // on page ready, load description
      this.querySelectorAll('.product__description--header div')[0].click();
    }
    
  handleReadMoreClick() {
    this.readMore.classList.toggle("more");
    this.readMore.classList.toggle("less");

    this.expandReadMore = !this.expandReadMore;

    if (!this.expandReadMore) {
      var content = this.originalDetailsHTML.split(/<p>---<\/p>|---/)[0];
      this.querySelectorAll('.tab')[0].querySelector('.content').innerHTML = content;
      this.querySelectorAll('.tab')[0].querySelector('.content').append(this.readMore);
    } else {
      this.querySelectorAll('.tab')[0].querySelector('.content').innerHTML = this.originalDetailsHTML.replace(/<p>---<\/p>|---/, '');
      this.querySelectorAll('.tab')[0].querySelector('.content').append(this.readMore);
    }
  }

  resetReadMoreState() {
    // Reset to initial state
  this.expandReadMore = false;
  this.readMore.classList.add("more");
  this.readMore.classList.remove("less");
  
  if (this.originalDetailsHTML.includes('---')) {
    var content = this.originalDetailsHTML.split(/<p>---<\/p>|---/)[0].replace("<p></p>", "");
    const detailsTab = this.querySelectorAll('.tab')[0];
    if (detailsTab) {
      const contentElement = detailsTab.querySelector('.content');
      if (contentElement) {
        contentElement.innerHTML = content;
        contentElement.append(this.readMore);
      }
    }
  }
  }

  initializeReadMore() {
    // Remove any existing event listeners
    this.readMore.removeEventListener('click', this.handleReadMoreClick);
    // Add the event listener
    this.readMore.addEventListener('click', this.handleReadMoreClick);
  }

    initializeTabs() {
      this.querySelectorAll('.product__description--header div').forEach((tabItem) => {
        tabItem.addEventListener('click', () => {
          this.querySelectorAll('.product__description--header div').forEach((clickedElement) => {
            clickedElement.classList.remove('active');
          });

          var dataItemTarget = tabItem.dataset.target;

          tabItem.classList.add('active');

          this.tabs.forEach((tabContent) => {
            let tabTarget = tabContent.dataset.target;

            if (tabTarget == 'details') {
              // if innerHTML includes "---" then only keep the first segment
              const delimiterRegex = /<p>---<\/p>|---|<br data-mce-fragment="1">---<br data-mce-fragment="1">/;
              if (this.originalDetailsHTML.includes('---')) {
                this.expandReadMore = false;
                this.readMore.classList.add("more")
                this.readMore.classList.remove("less")
                var content = this.originalDetailsHTML.split(delimiterRegex)[0].replace("<p></p>","");
                
                tabContent.querySelector('.content').innerHTML = content;
                tabContent.querySelector('.content').append(this.readMore);
              }
            }

            if (tabTarget == 'delivery') {
              let tabTargetUrl = tabContent.dataset.pageurl;
              fetch(tabTargetUrl)
                .then((response) => response.text())
                .then((text) => {
                  const parser = new DOMParser();
                  const html = parser.parseFromString(text, 'text/html');
                  const content = html.querySelector('main section .page-width div').innerHTML;
                  tabContent.innerHTML = content;
                });
            }

            if (tabTarget == dataItemTarget) {
              tabContent.classList.add('active');
            } else {
              tabContent.classList.remove('active');
            }
          });
        });
      });
    }
  }

  customElements.define('product-description', ProductDescription);
}
